export const BASE_PLAN_LINE_ITEM_ID = 'base-plan-AC11301F-0EB4-4EFE-84D7-AD621A8DC6D5';
export const SHIPMENT_LIMIT_LINE_ITEM_ID = 'shipment-limit-45058981-4C79-4D81-91B9-62109560059D';
export const USER_COST_LINE_ITEM_ID = 'users-D81C07AA-38EA-4D1E-A1EE-40CB87CFDFB6';
export const YOUR_CARRIER_COST_LINE_ITEM_ID = 'your-carrier-3E5F1B5B-1F9F-4F9A-9F9B-1B5B1F9F4F9A';
export const ANALYTICS_LICENSE_COST_LINE_ITEM_ID = 'analytics-licenses-7A3E2C4D-9B1F-4D8E-A5C6-3F2E1D0B9A8C';
